import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=06a7bb2e&scoped=true&"
import script from "./Fieldset.vue?vue&type=script&lang=js&"
export * from "./Fieldset.vue?vue&type=script&lang=js&"
import style0 from "./Fieldset.vue?vue&type=style&index=0&id=06a7bb2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7bb2e",
  null
  
)

export default component.exports